import React from 'react'
import NavItem from './NavItem'

const df = { display: 'flex' }
const fdc = { flexDirection: 'column' }


export default (props) => {
  const navItems = props.data.map((item, i) => {
    const url_split = item.url.split('/')
    const url_path = url_split[3]
    return (
      <NavItem
        key={i} 
        title={item.title}
        url={url_path}
        object={item.object}
        menu_order={item.menu_order}
      />
    )
  });

  return (
    <div data-c="NavList">
      <div style={{...df, ...fdc}}>
        {navItems}
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/navigation/NavList.js